import { SpineView, spineLoader } from '@play-co/timestep-spine';
import { playSpineAnimationSequence } from 'src/lib/ui/utils/spine';
import { Container, randomItem } from '../../../odie';
import { getMatch2AssetPath } from '../../util/assets';
import { blockPositionView } from '../../util/blockTools';
import { GrassBlockProps } from './GrassBlock';

type GrassVariant = 'A' | 'B' | 'C';
type GrassStage = 'mushroom' | 'nomushroom';
type GrassAnimation = 'idle' | 'shake';

const grassVariants: GrassVariant[] = ['A', 'B', 'C'];

const grassSpine = {
  loadMethod: spineLoader,
  url: getMatch2AssetPath('blocks/grass/animation/spine.grass_and_mushrooms'),
};

const grassParticleAssets = [
  getMatch2AssetPath('blocks/grass/leaf_1.png'),
  getMatch2AssetPath('blocks/grass/leaf_2.png'),
  getMatch2AssetPath('blocks/grass/leaf_3.png'),
  getMatch2AssetPath('blocks/grass/mushroom_1.png'),
  getMatch2AssetPath('blocks/grass/mushroom_2.png'),
  getMatch2AssetPath('blocks/grass/mushroom_3.png'),
];

export class GrassBlockView extends Container {
  private spine?: SpineView;
  private readonly grassVariant = randomItem(grassVariants);
  private _count: number;

  constructor(props: GrassBlockProps, count = props.options[0].count) {
    super();

    this._count = count;
    blockPositionView(this, props);
    this.createSpine();
  }

  public static assets() {
    return [grassSpine, ...grassParticleAssets];
  }

  public get count(): number {
    return this._count;
  }

  public set count(value: number) {
    if (this._count === value) return;
    this._count = value;
    this.playShakeAnimation();
  }

  private async createSpine() {
    if (this.spine) return;
    await spineLoader(grassSpine.url);
    this.spine = new SpineView({
      superview: this.view,
      spinePath: grassSpine.url,
      scale: 0.66,
      offsetY: 2,
    });
    this.playShakeAnimation();
  }

  public playShakeAnimation() {
    if (!this.spine) return;
    playSpineAnimationSequence(this.spine, {
      sequence: [this.getAnimationName('shake'), this.getAnimationName('idle')],
      loopLast: true,
      clear: true,
    });
  }

  private getStage(): GrassStage {
    if (this._count > 1) {
      return 'mushroom';
    }
    return 'nomushroom';
  }

  private getAnimationName(animation: GrassAnimation): string {
    return `leaves${this.grassVariant}_${this.getStage()}_${animation}`;
  }
}

export function _createGrassBlockView(
  props: GrassBlockProps,
  option: number,
): GrassBlockView {
  const optionDef = props.options[option];
  return new GrassBlockView(props, optionDef.count);
}
